module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index container"
  }, [_c('video', {
    staticClass: "index__video",
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "poster": "/static/images/bill.jpg"
    },
    domProps: {
      "muted": _vm.muted
    },
    on: {
      "play": _vm.enableSoundControl
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/bill.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/static/videos/bill.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), (_vm.showSoundControls) ? _c('div', {
    staticClass: "index__sound-control"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toggleSound
    }
  }, [_vm._v(_vm._s(_vm.soundText))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07310d13!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 379
// module chunks = 2